import React, { useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import { hideUpgradeCardModal } from '../../actions'
import { addUpgradeReason } from 'utils/general'
import CustomModal from 'components/CustomModal/CustomModal'

import './upgrade-modal-content.css'

const UpgradeModal = ({ title, gif, show, desc, cta, onClick, dispatch }) => {
  const onUpgradeCardClick = () => {
    dispatch(hideUpgradeCardModal())

    if (onClick) setTimeout(onClick, 300)
  }

  useEffect(() => {
    if (show) {
      addUpgradeReason(title)
    }
  }, [show, title])

  return (
    <CustomModal
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={() => dispatch(hideUpgradeCardModal())}
      dialogClassName="upgrade-modal-content"
      backdropClassName="upgrade-modal-backdrop"
      centered
      enforceFocus={false}
    >
      <div className="round-24 bg-white flex">
        <div className="p-4">
          <h2 className="mb-2 bold color-purple-2 font-22">{title}</h2>
          <p className="grey">{desc}</p>

          {gif && <img className="upgrade-modal" src={gif} style={{ width: '100%', maxWidth: 450 }} />}

          <Button className="mt-3 tr-upgrade-card-cta float-end" variant="purple" onClick={onUpgradeCardClick}>
            {cta || 'Upgrade'} →
          </Button>
        </div>
        {!gif && <div style={{ width: 200 }} className="upgrade-modal-img upgrade-bg-purple"></div>}
      </div>
    </CustomModal>
  )
}

const mapStateToProps = ({ upgrade }) => ({
  ...upgrade
})

const mapDispatchToProps = (dispatch) => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(UpgradeModal)
